

















































// @ts-nocheck
// ^^^^^^^^^^^ Disabled TypeScript linter in this file because it doesn't understand Vue components
// which is not wrapped in Vue.extend(), and we can't use Vue.extend() in Sanity serializers
// because of how src/components/SanityBlockContent.vue initializes the serializers.

import { urlFor } from '@/config/sanity';

export default {
  name: 'SanityRichTextImageSerializer',
  props: {
    title: String,
    image: Object,
    description: String,
    size: String,
    placement: String,
    showTitleDescription: Boolean,
    hideBorderShadow: Boolean,
  },
  methods: {
    urlFor,
  },
  computed: {
    imageSize() {
      switch (this.placement) {
      case 'prominent':
        return 600;
      case 'full-width':
        return 960;
      default:
        return 450;
      }
    },
    showImageGutter() {
      return !!this.showTitleDescription && (!!this.title && !!this.description);
    },
    showBorderShadow() {
      return !!this.hideBorderShadow === false;
    },
    imageStyles() {
      const styles = {
        'border-bottom-left-radius': this.showImageGutter ? 0 : '8px',
        'border-bottom-right-radius': this.showImageGutter ? 0 : '8px',
      };
      if (this.hideBorderShadow) {
        styles['box-shadow'] = 'none';
      }
      return styles;
    },
  },
};
